module.exports = __webpack_public_path__ + "static/img/jsmagic1pict2.3fac6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jsmagic1pict2.jpg
// module id = cNXZ
// module chunks = 0